<svg
  class="spinner {{ color() }}"
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 24 24"
  fill="none"
>
  <circle
    class="track"
    cx="12"
    cy="12"
    r="9"
    [attr.stroke-width]="strokeWidth()"
  />
  <circle
    class="arc"
    cx="12"
    cy="12"
    r="9"
    pathLength="100"
    [attr.stroke-width]="strokeWidth()"
  />
</svg>
